import { render, staticRenderFns } from "./InputPriceElement.vue?vue&type=template&id=8f739ef2&scoped=true&"
import script from "./InputPriceElement.vue?vue&type=script&lang=js&"
export * from "./InputPriceElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f739ef2",
  null
  
)

export default component.exports